import React from 'react'
import {
  Box,
  Typography,
  Grid,
  Button,
  Card,
  CardMedia,
  CardContent
} from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { pallets } from '../../data/pallets'

const FeaturedPallets = () => {
  const navigate = useNavigate()

  const navigateLink = (link) => {
    navigate(link)
    window.scrollTo(0, 0)
  }

  const featuredPallets = pallets.filter(
    pallet => pallet.featured
  )

  return (
    <Box
      sx={{
        py: { xs: 6, md: 8 },
      }}
    >
      <Box
        sx={{
          maxWidth: '1200px',
          width: '90%',
          mx: 'auto'
        }}
      >
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: '#fff',
            textAlign: 'center',
            mb: 2
          }}
        >
          Featured Pallets
        </Typography>

        <Typography
          sx={{
            color: '#C8C8C8',
            textAlign: 'center',
            maxWidth: '700px',
            mx: 'auto',
            mb: 6,
            fontSize: '1.1rem'
          }}
        >
          Browse some of our most popular pallet solutions suitable for
          storage, transportation and distribution requirements.
        </Typography>

        <Grid container spacing={3} justifyContent="center">
          {featuredPallets.map((pallet) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              lg={2.4}
              key={pallet.id}
            >
              <Card
                sx={{
                  height: '100%',
                  backgroundColor: '#222023',
                  border: '1px solid rgba(87,200,77,0.15)',
                  transition: 'all 0.3s ease',

                  '&:hover': {
                    transform: 'translateY(-5px)',
                    borderColor: '#57C84D'
                  }
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    p: 2
                  }}
                >
                  <CardMedia
                    component="img"
                    image={pallet.image}
                    alt={pallet.name}
                    sx={{
                      height: 150,
                      width: '100%',
                      objectFit: 'contain'
                    }}
                  />
                </Box>

               <CardContent
                  sx={{
                    textAlign: 'center',
                    display: 'flex',
                    flexDirection: 'column',
                    height: '224px'
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      color: '#fff',
                      fontWeight: 600,
                      mb: 1
                    }}
                  >
                    {pallet.name}
                  </Typography>

                  <Typography
                    sx={{
                      color: '#57C84D',
                      fontWeight: 600,
                      mb: 2
                    }}
                  >
                    {pallet.dimensions}
                  </Typography>

                  <Typography
                    sx={{
                      color: '#C8C8C8',
                      fontSize: '0.95rem',
                      lineHeight: 1.6,
                      flexGrow: 1
                    }}
                  >
                    {pallet.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Box
          sx={{
            textAlign: 'center',
            mt: 2
          }}
        >
          <Button
            size="large"
            onClick={() => navigateLink('/pallets')}
            sx={{
              backgroundColor: '#0A9B48',
              color: '#fff',
              minWidth: '220px',
              py: 2,
              px: 4,
              fontSize: '1rem',
              fontWeight: 700,
              letterSpacing: '1px',
              borderRadius: 0,

              '&:hover': {
                transform: 'translateY(-5px)',
                borderColor: 'white',
                border: '1px solid',
                boxShadow: '0 10px 30px rgba(87,200,77,0.15)',
                backgroundColor: '#57C84D'
              }
            }}
          >
            VIEW ALL PALLETS →
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default FeaturedPallets